(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leva-calltoaction"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('leva-opportunity')) {
    customElements.define('leva-opportunity', class extends HTMLElement {
      connectedCallback() {
        this.output = this.querySelector('[data-typed-text]');
        if (!this.output) return;
        this.fullText = this.querySelector('.leva-opportunity__sr').textContent.trim();
        this.characters = typeof Intl.Segmenter === 'function'
          ? Array.from(new Intl.Segmenter('fr', { granularity: 'grapheme' }).segment(this.fullText), item => item.segment)
          : Array.from(this.fullText);
        this.index = 0;
        this.baseDelay = Number(this.dataset.typingDelay) || 65;
        this.inView = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.classList.remove('leva-opportunity--done');
        this.classList.add('leva-opportunity--ready');
        this.output.textContent = '';
        this.onState = () => this.sync();
        this.motion.addEventListener('change', this.onState);
        document.addEventListener('visibilitychange', this.onState);
        this.onSelect = () => {
          this.inView = true;
          this.classList.add('leva-opportunity--visible');
          this.sync();
        };
        this.addEventListener('shopify:section:select', this.onSelect);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting;
            if (this.inView) this.classList.add('leva-opportunity--visible');
            this.sync();
          }, { threshold: 0.1 });
          this.observer.observe(this);
        } else {
          this.onSelect();
        }
        this.sync();
      }
      sync() {
        window.clearTimeout(this.timer);
        this.classList.toggle('leva-opportunity--away', !this.inView || document.hidden);
        if (this.motion.matches) {
          this.output.textContent = this.fullText;
          this.index = this.characters.length;
          this.classList.add('leva-opportunity--done', 'leva-opportunity--visible');
          return;
        }
        if (!this.inView || document.hidden || this.index >= this.characters.length) return;
        this.timer = window.setTimeout(() => this.typeNext(), this.index === 0 ? 550 : 180);
      }
      typeNext() {
        if (!this.isConnected || !this.inView || document.hidden) return;
        const character = this.characters[this.index++];
        this.output.textContent = this.characters.slice(0, this.index).join('');
        if (this.index >= this.characters.length) {
          this.classList.add('leva-opportunity--done');
          return;
        }
        let delay = this.baseDelay * (0.55 + Math.random() * 1.15);
        if (/[.,;:!?…]/u.test(character)) delay += 350 + Math.random() * 450;
        else if (/\s/u.test(character)) delay += Math.random() < 0.35 ? 240 + Math.random() * 400 : 70;
        else if (Math.random() < 0.045) delay += 160 + Math.random() * 200;
        this.timer = window.setTimeout(() => this.typeNext(), delay);
      }
      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.onState);
        document.removeEventListener('visibilitychange', this.onState);
        this.removeEventListener('shopify:section:select', this.onSelect);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leva-hero1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('leva-ai-flow')) {
    customElements.define('leva-ai-flow', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.stage = 0;
        this.timer = null;
        this.inView = !('IntersectionObserver' in window);
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.dataset.autoplay === 'true';
        this.dataset.stage = '0';

        this.onState = () => this.sync();

        document.addEventListener('visibilitychange', this.onState);
        this.motion.addEventListener('change', this.onState);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.sync();
          }, { threshold: 0.15 });

          this.observer.observe(this);
        }

        this.sync();
      }

      sync() {
        window.clearInterval(this.timer);
        this.timer = null;

        const running =
          this.autoplay &&
          !this.motion.matches &&
          this.inView &&
          !document.hidden;

        this.dataset.running = String(running);

        if (!this.autoplay || this.motion.matches) {
          this.stage = 3;
          this.dataset.stage = '3';
        }

        if (!running) return;

        this.timer = window.setInterval(() => {
          this.stage = (this.stage + 1) % 4;
          this.dataset.stage = String(this.stage);
        }, 2400);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onState);
        this.motion?.removeEventListener('change', this.onState);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["leva-transition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('levya-text-flight')) {
    customElements.define('levya-text-flight', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.words = Array.from(
          this.querySelectorAll('.leva-rotate__word')
        ).filter((word) => word.textContent.trim() !== '');

        this.index = 0;
        this.timer = null;
        this.inView = !('IntersectionObserver' in window);
        this.motion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        );

        this.querySelectorAll('.leva-rotate__word').forEach((word) => {
          word.classList.remove('is-active');
        });

        this.words[0]?.classList.add('is-active');

        this.onState = () => this.sync();

        document.addEventListener('visibilitychange', this.onState);
        this.motion.addEventListener('change', this.onState);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.sync();
          });

          this.observer.observe(this);
        }

        this.sync();
      }

      sync() {
        window.clearInterval(this.timer);
        this.timer = null;

        const running =
          this.inView &&
          !document.hidden &&
          !this.motion.matches;

        this.dataset.running = String(running);

        if (!running || this.words.length < 2) return;

        this.timer = window.setInterval(() => {
          this.words[this.index].classList.remove('is-active');
          this.index = (this.index + 1) % this.words.length;
          this.words[this.index].classList.add('is-active');
        }, 2000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.onState);
        this.motion?.removeEventListener('change', this.onState);
        this.dataset.running = 'false';
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levya-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('levya-hero')) {
    customElements.define('levya-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.button = this.querySelector('.leva-hero__pause');

        if (this.button) {
          this.button.hidden = false;

          this.onToggle = () => {
            const paused = this.dataset.paused !== 'true';

            this.dataset.paused = String(paused);
            this.button.setAttribute('aria-pressed', String(paused));
            this.button.setAttribute(
              'aria-label',
              paused
                ? 'Reprendre l’animation de LEVY'
                : 'Mettre en pause l’animation de LEVY'
            );
            this.button.textContent = paused ? 'Reprendre' : 'Pause';
          };

          this.button.addEventListener('click', this.onToggle);
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.dataset.offscreen = String(!entries[0].isIntersecting);
          });

          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onToggle);
        this.observer?.disconnect();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
